import { useEffect, useMemo } from 'react'
import { MapContainer, TileLayer, CircleMarker, Polyline, Tooltip, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'

// Centro default (Maricá/RJ) quando não há nenhuma posição conhecida.
const DEFAULT_CENTER = [-22.92, -42.82]

/** Ajusta o zoom para caber todos os pontos — só quando o conjunto muda. */
function FitBounds({ points, fitKey }) {
  const map = useMap()
  useEffect(() => {
    if (!points.length) return
    if (points.length === 1) {
      map.setView(points[0], Math.max(map.getZoom(), 15))
      return
    }
    map.fitBounds(points, { padding: [32, 32], maxZoom: 17 })
    // fitKey controla quando reenquadrar; points muda a cada refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, fitKey])
  return null
}

/**
 * Mapa Leaflet do MDM. Usa CircleMarker (sem ícones raster — o ícone default do
 * Leaflet quebra com o bundler) e opcionalmente uma trilha.
 *
 * markers: [{ id, lat, lng, color, label, onClick }]
 * trail:   [[lat, lng], ...]
 */
export default function MdmMap({ markers = [], trail = null, height = 420, fitKey }) {
  const points = useMemo(() => {
    const pts = markers.filter((m) => m.lat != null && m.lng != null).map((m) => [m.lat, m.lng])
    if (trail?.length) pts.push(...trail)
    return pts
  }, [markers, trail])

  const effectiveFitKey = fitKey ?? `${markers.length}:${trail?.length ?? 0}`

  return (
    <div className="rounded-lg overflow-hidden border border-gray-200" style={{ height }}>
      <MapContainer center={points[0] || DEFAULT_CENTER} zoom={points.length ? 13 : 10} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {trail?.length > 1 && <Polyline positions={trail} pathOptions={{ color: '#3b82f6', weight: 3, opacity: 0.8 }} />}
        {markers
          .filter((m) => m.lat != null && m.lng != null)
          .map((m) => (
            <CircleMarker
              key={m.id}
              center={[m.lat, m.lng]}
              radius={m.radius ?? 9}
              pathOptions={{ color: '#ffffff', weight: 2, fillColor: m.color || '#3b82f6', fillOpacity: 0.95 }}
              eventHandlers={m.onClick ? { click: m.onClick } : undefined}
            >
              {m.label && <Tooltip direction="top" offset={[0, -8]}>{m.label}</Tooltip>}
            </CircleMarker>
          ))}
        <FitBounds points={points} fitKey={effectiveFitKey} />
      </MapContainer>
    </div>
  )
}
